import React from 'react';
import ConfigSection from './ConfigSection';
import styled from 'styled-components';

const ConfigPanel = styled.div`
  padding: 20px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  margin: 32px auto;
  max-height: 1040px;

  h3 {
    font-size: 1.5em;
    margin-bottom: 1em;
    color: #333;
  }

  .config-section {
    margin-bottom: 20px;

    h4 {
      font-size: 1.2em;
      margin-bottom: 0.5em;
      color: #555;
    }

    input[type="color"],
    input[type="number"] {
      display: block;
      width: 100%;

    }
  }
`;

const ThemeConfigPanel = ({
  styles,
  handleStyleChange,
  applyPreset,
  saveCustomTheme,
  loadCustomTheme,
}) => {
  return (
    <ConfigPanel>
      <h3>Customize Theme</h3> 
      <ConfigSection
        title="Colors" 
        inputs={[
          { type: 'color', label: 'Background Color', name: 'backgroundColor', value: styles.backgroundColor, onChange: handleStyleChange },
          { type: 'color', label: 'Secondary Background Color', name: 'secondaryBackgroundColor', value: styles.secondaryBackgroundColor, onChange: handleStyleChange },
          { type: 'color', label: 'Header Background Color', name: 'headerBackgroundColor', value: styles.headerBackgroundColor, onChange: handleStyleChange },
          { type: 'color', label: 'Header Text Color', name: 'headerTextColor', value: styles.headerTextColor, onChange: handleStyleChange },
          { type: 'color', label: 'Sub Header Text Color', name: 'subheaderTextColor', value: styles.subheaderTextColor, onChange: handleStyleChange },
          { type: 'color', label: 'Text Color', name: 'textColor', value: styles.textColor, onChange: handleStyleChange },
        ]}
      />
      <ConfigSection
        title="Font Sizes"
        inputs={[
          { type: 'number', label: 'Header Font Size (em)', name: 'headerFontSize', value: styles.headerFontSize, onChange: handleStyleChange },
          { type: 'number', label: 'Subheader Font Size (em)', name: 'subheaderFontSize', value: styles.subheaderFontSize, onChange: handleStyleChange },
          { type: 'number', label: 'Body Font Size (em)', name: 'bodyFontSize', value: styles.bodyFontSize, onChange: handleStyleChange },
        ]}
      />
      <ConfigSection
        title="Preset Themes"
        inputs={[
          { type: 'button', label: 'Default', onClick: () => applyPreset('default') },
          { type: 'button', label: 'Dark', onClick: () => applyPreset('dark') },
          { type: 'button', label: 'Light', onClick: () => applyPreset('light') },
        ]}
      />
      <ConfigSection
        title="Custom Theme"
        inputs={[
          { type: 'button', label: 'Save Custom Theme', onClick: saveCustomTheme },
          { type: 'button', label: 'Load Custom Theme', onClick: loadCustomTheme },
        ]}
      />
    </ConfigPanel>
  );
};

export default ThemeConfigPanel;
